export default "__VITE_ASSET__IeeP38G8__"